import makeStyles from '@mui/styles/makeStyles';

const createClasses = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box'
  },
  centered: {
    flex: '1 1 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

export default createClasses;
